/**
 * WordPress dependencies
 */
import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';

/**
 * External Dependencies
 */
import classNames from 'classnames';

// block save function
const Save = props => {
    const { attributes } = props;
    const { uniqueId } = attributes;

    /**
     * Block Props
     */
    const blockProps = useBlockProps.save({
        className: classNames('wp-block-progressmatify-buttons', uniqueId)
    });

    // Inner blocks
    const innerBlockProps = useInnerBlocksProps.save({
        className: 'progressmatifybars-inner-blocks'
    });

    return (
        <div {...blockProps}>
            <div {...innerBlockProps} />
        </div>
    );
};

export default Save;
